// config.js
import Cookies from "js-cookie";
const bz_utkn = Cookies.get("bz_utkn") && JSON.parse(Cookies.get("bz_utkn"));
const bz_uinf = Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));
const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  token: bz_utkn ? "Bearer " + bz_utkn : null,
  user: bz_uinf ? bz_uinf : null,
};

export default config;
